import { render, staticRenderFns } from "./SelectAgreementComponent.vue?vue&type=template&id=70fb2372"
import script from "./SelectAgreementComponent.vue?vue&type=script&lang=js"
export * from "./SelectAgreementComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectAgreementComponent.vue?vue&type=style&index=0&id=70fb2372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports